import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    editIconContainer: {
        justifyContent: "center",
        position: "absolute",
        alignItems: "center",
        borderWidth: 1,
        bottom: -4,
        height: 32,
        right: -4,
        width: 32
    },
    avatarContainer: {
        alignItems: "center",
        position: "relative",
        alignSelf: "center"
    },
    container: {
        maxHeight: "85%",
        width: "100%"
    },
    inputsContainer: {
        width: "100%"
    },
    scrollView: {
        flexShrink: 1
    }
});
export default stylesheet;
